module.exports = __webpack_public_path__ + "img/pr-9.d0a199c8.png";